import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTracker = ({ completedCount, totalCount, progressPercentage }) => {
  return (
    <div className="bg-gradient-to-r from-primary/10 to-secondary/10 border border-primary/20 rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl font-heading font-bold text-foreground mb-1">
            Your Learning Progress
          </h2>
          <p className="text-sm text-muted-foreground">
            Complete tutorials to earn compliance training certification badges
          </p>
        </div>
        <div className="bg-primary/10 p-3 rounded-full">
          <Icon name="Award" size={32} color="var(--color-primary)" />
        </div>
      </div>

      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-semibold text-foreground">
            {completedCount} of {totalCount} tutorials completed
          </span>
          <span className="text-sm font-bold text-primary">
            {progressPercentage}%
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-3 overflow-hidden">
          <div
            className="bg-gradient-to-r from-primary to-secondary h-full rounded-full transition-all duration-500"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      {/* Badges */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <div className={`p-2 rounded-full ${
            completedCount >= 3 ? 'bg-success/20' : 'bg-muted'
          }`}>
            <Icon 
              name="Award" 
              size={20} 
              color={completedCount >= 3 ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
            />
          </div>
          <div>
            <p className="text-xs font-semibold text-foreground">Beginner</p>
            <p className="text-xs text-muted-foreground">3 tutorials</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className={`p-2 rounded-full ${
            completedCount >= 6 ? 'bg-warning/20' : 'bg-muted'
          }`}>
            <Icon 
              name="Award" 
              size={20} 
              color={completedCount >= 6 ? 'var(--color-warning)' : 'var(--color-muted-foreground)'}
            />
          </div>
          <div>
            <p className="text-xs font-semibold text-foreground">Intermediate</p>
            <p className="text-xs text-muted-foreground">6 tutorials</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className={`p-2 rounded-full ${
            completedCount >= 9 ? 'bg-primary/20' : 'bg-muted'
          }`}>
            <Icon 
              name="Award" 
              size={20} 
              color={completedCount >= 9 ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
            />
          </div>
          <div>
            <p className="text-xs font-semibold text-foreground">Expert</p>
            <p className="text-xs text-muted-foreground">9 tutorials</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressTracker;